import { ClientAnalytics } from './clientAnalytics'

// ── Tab lifecycle ──
type TabEvent =
  | 'workspace:tab:add'
  | 'workspace:tab:close'
  | 'workspace:tab:switch'
  | 'workspace:tab:reorder'
  | 'workspace:tab:move_to_split'
  | 'workspace:tab:move'

// ── Split view ──
type SplitEvent =
  | 'workspace:split:open'
  | 'workspace:split:close'
  | 'workspace:split:resize'

// ── Load ──
type LoadEvent =
  | 'workspace:load'

export type WorkspaceAnalyticsEvent =
  | TabEvent
  | SplitEvent
  | LoadEvent

export function trackWorkspace(event: WorkspaceAnalyticsEvent, properties?: Record<string, unknown>) {
  ClientAnalytics.track(event, properties)
}
